import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const CreateDealPage = withSuspense(lazy(() => import('./create-deal')));
export default CreateDealPage;
